import { createAPI } from '../../common'

export default {
    // 获取根文件夹
    getCatRoot: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.benjo0dbu0spput', 'get', config, {
            neverLoading: true
        }),
    //备注举报
    postRemark: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0fyqptf0sfnbsl', 'post', config),
    // 通过拒绝举报
    postExposeStatus: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0fyqptf0tubuvt', 'post', config),
    // 下载
    postExposeExport: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ojt.ejtdvtt0ojt0fyqptf0fyqpsu', 'post', config)

}
